import { FETCH_MTOKNA_DOGS, CLEAN_MTOKNA_DOGS, CHANGE_MTOKNA_DOG, DELETE_MTOKNA_DOG } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_DOGS_DEFAULT_STATE = {};

const MtoknaDogsReducer = (state = MTOKNA_DOGS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_DOGS:
            return payload;

        case CHANGE_MTOKNA_DOG:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_DOGS:
        case DELETE_MTOKNA_DOG:
            return MTOKNA_DOGS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaDogsReducer;
